// extracted by mini-css-extract-plugin
module.exports = {"container":"AppBarNotifications_container__1UcTG"};